var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cancel-a",
    d: "M32,0 C14.326888,0 0,14.326888 0,32 C0,49.673112 14.326888,64 32,64 C49.673112,64 64,49.673112 64,32 C64,14.326888 49.673112,0 32,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cancel-b",
    width: "106.2%",
    height: "106.2%",
    x: "-3.1%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    xlinkHref: "#cancel-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cancel-b)",
    xlinkHref: "#cancel-a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.55288,2.91158612 L37.0884139,6.44712003 L23.5345861,19.9995861 L37.0884139,33.55288 L33.55288,37.0884139 L19.9995861,23.5345861 L6.44712003,37.0884139 L2.91158612,33.55288 L16.4645861,19.9995861 L2.91158612,6.44712003 L6.44712003,2.91158612 L19.9995861,16.4645861 L33.55288,2.91158612 Z",
    transform: "translate(12 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCancel);
export default __webpack_public_path__ + "static/media/camera_cancel.9405887406725b02acf7a3e66aee3ca2.svg";
export { ForwardRef as ReactComponent };